import React from 'react';
import PropTypes from 'prop-types';
import Imgcomponent, { LOADING_IMG } from '../../../HOCs/ImageHocs';

function RatingContainer({ ratings, ratingImages, mustShowRatingImage }) {

    const getRatingImage= (ratingName) => {
      return ratingImages.find(ratingImage => ratingImage.name === ratingName)
     }
    return (
        <React.Fragment>
         { ratingImages?.length > 0 && mustShowRatingImage 
         
         ? ratings.map((rating) => 
            <Imgcomponent
                  className="contentOverviewRatingImage"
                  src={getRatingImage(rating)?.image}
                  loading={LOADING_IMG.EAGER}
                />
            )
        
         : <p className="contentOverviewRating">{ratings?.join(', ')}</p>
        }
        </React.Fragment>
    );
}

RatingContainer.propTypes = {
  ratings: PropTypes.array,
  ratingImage: PropTypes.array,
  mustShowRatingImage: PropTypes.bool
  
}

export default React.memo(RatingContainer);
